var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('AdminNav'),_c('h3',[_vm._v("Stats")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('AdminStatsNav')],1),_vm._m(0)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-9"},[_c('table',{staticClass:"table table-sm"},[_c('tr')])])
}]

export { render, staticRenderFns }